import React from 'react'
import { Link } from 'react-router-dom'
import BGImg from "../../assets/img/bg/bc_camaking.jpg";
function Main({title,subtitle,newtitle}) {
  return (
    <>
        <section className="breadcrumb-area d-flex align-items-center" style={{ 
            background: `url(${BGImg}) no-repeat center center / cover`,
            backgroundSize: 'cover',
            width: '100%',
            height: '100%',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1
            }}></div>
            <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                <div className="row align-items-center">
                    <div className="col-xl-12 col-lg-12">
                        <div className="breadcrumb-wrap text-center">
                            <div className="breadcrumb-title">
                                <h2>{title}</h2>    
                                <div className="breadcrumb-wrap">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to ="/">{subtitle}</Link></li>
                                            <li className="breadcrumb-item active" aria-current="page">{newtitle}</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main